<template>
  <div>
    <br />
     <app-history
      @clicked="$router.push('/khorooj-request')"
      title="درخواست خروج از کشور"
    />
    <app-history
      @clicked="$router.push('/khorooj-last')"
      title="اعلام وضعیت سفر"
    />
    <app-history
      @clicked="$router.push('/khorooj-history')"
      title="پیگیری و مشاهده سوابق"
    />
    <app-history
      @clicked="$router.push('/amrieh')"
      title="درخواست امریه"
    />
  </div>
</template>

<script>
import HistoryButton from "@/components/HistoryButton";
export default {
  components: {
    appHistory: HistoryButton,
  },
};
</script>
<style scoped>
.register {
  margin: 20px 20px 0 20px !important;
}
</style>
